import { type RootState } from '@/state/store';

export const selectAdminItems = (state: RootState) => state.adminItems.items;

export const selectAdminItemsOpenCount = (state: RootState) =>
  state.adminItems.openCount;

export const selectAdminItemsLoading = (state: RootState) =>
  state.adminItems.loading;

export const selectAdminItemsPage = (state: RootState) => state.adminItems.page;

export const selectAdminItemsLastPage = (state: RootState) =>
  state.adminItems.lastPage;

export const selectAdminItemsTotal = (state: RootState) =>
  state.adminItems.total;

export const selectAdminItemsPerPage = (state: RootState) =>
  state.adminItems.perPage;

export const selectAdminItemsStatus = (state: RootState) =>
  state.adminItems.status;
